import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import Login from "./Login";
import SignUp from "./SignUp";
import ForgotPassword from "./ForgotPassword";
import { useNavigate } from "react-router-dom";
import AppContext from "../../AppContext";

const Auth = ({ redirect }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const navigate = useNavigate();
  const { toggleAuthModal } = useContext(AppContext);

  const handleSwitch = () => {
    setIsLogin((curr) => !curr);
  };

  const handleNavigateToOnboard = () => {
    toggleAuthModal(false);
    navigate("onboard");
  };

  const handleForgotPassword = () => {
    setIsForgotPassword(true);
  };

  const handleClose = () => {
    toggleAuthModal(false);
  };

  if (isForgotPassword) {
    return (
      <ForgotPassword
        onClose={handleClose}
        onReturn={() => setIsForgotPassword(false)}
      />
    );
  }

  if (isLogin) {
    return (
      <Login
        onSwitch={handleSwitch}
        onClose={handleClose}
        onForgotPassword={handleForgotPassword}
        onNavigateToOnboard={handleNavigateToOnboard}
        redirect={redirect}
      />
    );
  }

  return (
    <SignUp
      onSwitch={handleSwitch}
      onNavigateToOnboard={handleNavigateToOnboard}
      onForgotPassword={handleForgotPassword}
      onClose={handleClose}
    />
  );
};

Auth.propTypes = {};

export default Auth;
